module.exports = __webpack_public_path__ + "static/media/space.a4eb5f9c.jpg";